import { PoposedToTheSubCommittee3EditContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3EditContainer";
export function PoposedToTheSubCommittee3EditPage() {

    return (
        <PoposedToTheSubCommittee3EditContainer />
    )
}




